
import PagerConf from "../components/PagerConf";
import Filter from "../components/Filter";

import FilterService from "../services/filter";
import FilterInitializer from "./FilterInitializer";

type FilterLineProps = {
    servers: string[],
    ports: number[],
    onChange: () => void;
}

export default function FilterLine({onChange, servers, ports}: FilterLineProps) {

    function renderLineAlwaysVisible() {
        return (
            <tr className="trackers-filters">
                <td className="tracker-bulk-action"></td>
                <td colSpan={7} className="tracker-transversal-search">
                    <Filter type='simple' code='filter_transversal_search' onChange={() => onChange ? onChange() : null} />
                </td>
                <td className="tracker-pager" colSpan={2}>
                    <PagerConf onChange={() => onChange ? onChange() : null} />
                </td>
                <td className="tracker-filter">
                    <span className="reinit">
                        <FilterInitializer onChange={() => onChange ? onChange() : null} />
                    </span>
                </td>
            </tr>
        );
    }

    if (!FilterService.isOpen()) {
        return renderLineAlwaysVisible();
    }
    return (
        <>
        {renderLineAlwaysVisible()}
        <tr className="trackers-filters">
            <td className="tracker-bulk-action"></td>
            <td className="tracker-name">
                <Filter type='simple' code='filter_name' onChange={() => onChange ? onChange() : null} />
            </td>
            <td className="tracker-hardware_id">
                <Filter type='simple' code='filter_hardwareId' onChange={() => onChange ? onChange() : null} />
            </td>
            <td className={"tracker-battery " + (FilterService.isCorrectFilterBattery() ? 'correct': 'incorrect')}>
                <Filter type='comparator' code='filter_battery' onChange={() => onChange ? onChange() : null} />
            </td>
            <td className={"tracker-version " + (FilterService.isCorrectFilterVersion() ? 'correct': 'incorrect')}>
                <Filter type='comparator' code='filter_version' onChange={() => onChange ? onChange() : null} />
            </td>
            <td className={"tracker-date " + (FilterService.isCorrectFilterDate() ? 'correct': 'incorrect')}>
                <Filter type='date' code='filter_date' onChange={() => onChange ? onChange() : null} />
            </td>
            {/* <td className="tracker-updatable">
                <Filter type='switch' code='filter_viewUpdatable' icon="check" onChange={() => onChange ? onChange() : null} />
                <Filter type='switch' code='filter_viewNoUpdatable' icon="ban" onChange={() => onChange ? onChange() : null} />
            </td> */}
            <td className="tracker-url">
                <Filter type='select-string'
                    code='filter_server'
                    onChange={() => onChange ? onChange() : null}
                    options={servers}
                    all={FilterService.SERVER_URL_FILTER_ALL_VALUE}
                    />
            </td>
            <td className="tracker-port">
                <Filter type='select-number'
                    code='filter_port'
                    onChange={() => onChange ? onChange() : null}
                    options={ports}
                    all={FilterService.SERVER_PORT_FILTER_ALL_VALUE}
                    />
            </td>
            <td className="tracker-fleetstate">
                <Filter type='select-string'
                    code='filter_fleetstate'
                    onChange={() => onChange ? onChange() : null}
                    options={['ALL', 'ok', 'outdated', 'error']}
                    all={'ALL'}
                    />
            </td>
        </tr>
        </>
    );
}